import { FEATURE_FLAG } from '../types/FeatureFlag'
import { useFlag } from '@unleash/nextjs/client'

export const useFeatureFlag = (featureFlag: FEATURE_FLAG) => {
  return useFlag(featureFlag)
}
